import { each, selectAll } from '../shared/utils/dom';

/**
 * function is responsible for creating bar graphs in the Portal
 */
export default function Chart() {
  /**
   * Find all instances of .js-chart
   */
  const charts = document.querySelectorAll('.js-chart__chart');

  if (charts) {
    /**
     * Loop over all charts and update their bar graphs accordingly
     */
    each(charts, (chart) => {
      const points = [];
      const avgtemps = [];
      const lineValues = [];
      const bars = chart.querySelectorAll('.js-chart__bar');
      const horizontalLines = chart.querySelectorAll('.js-chart__horizontal-line');

      each(bars, (el) => {
        const ccf = parseInt(el.dataset.height, 10);
        points.push(ccf);

        const avgtempitem = el.querySelector('.js-chart__avg-temp');
        let avgtemp = 0;
        if (avgtempitem && avgtempitem.dataset.avgtemp) {
          avgtemp = parseInt(avgtempitem.dataset.avgtemp, 10);
        }
        avgtemps.push(avgtemp);
      });

      /**
       * equivalent to Math.max(1, 2, 3), but you can use
       * on programmatically constructed arrays of any size.
       */
      const max = Math.max.apply(null, points);
      const quarters = Math.ceil((max / 4) / 5) * 5;

      const minavgtemp = Math.min.apply(null, avgtemps);
      const maxavgtemp = Math.max.apply(null, avgtemps);
      const diffavgtemp = maxavgtemp - minavgtemp;
      let upperavgtemp = Math.ceil(diffavgtemp / 5) * 5;
      upperavgtemp *= 1.10;

      for (let i = 0; i < 5; i += 1) {
        lineValues.push(i * quarters);
      }

      const upper = quarters * 4;
      const canvas = chart.querySelector('.js-chart__chart__canvas');
      const ctx = canvas.getContext("2d");
      ctx.strokeStyle = '#73bde8';
      ctx.beginPath();
      let x1;
      let x2;
      let y1;
      let y2;
      let adjustedOffsetLeft = 18;
      if (canvas.clientWidth && canvas.clientWidth > 660) {
        adjustedOffsetLeft = 22;
      }
      let index = 0;
      each(bars, (el) => {
        setTimeout(() => {
          index += 1;
          const bar = el;
          // get the height data
          // actual ccf, divided by the max, multiplied by 100 for proper %
          const barHeight = (parseInt(el.dataset.height, 10) / upper) * 100;
          // set the height data
          bar.style.height = barHeight + '%'; // eslint-disable-line prefer-template
          if (index === 7) {
            const mobileusagetip = chart.querySelector(".js-chart__mobile_usage_tip");
            if (mobileusagetip) {
              mobileusagetip.style.bottom = (barHeight + 3) + '%'; // eslint-disable-line prefer-template
            }
          }
          const avgtempitem = el.querySelector('.js-chart__avg-temp');
          if (avgtempitem && avgtempitem.dataset.avgtemp) {
            let avgtemp = parseInt(avgtempitem.dataset.avgtemp, 10);
            avgtemp -= minavgtemp;
            avgtempitem.style.bottom = (((avgtemp / upperavgtemp) * canvas.height) - 5) + 'px'; // eslint-disable-line prefer-template
          }
          if (canvas) {
            const avgtempicon = el.querySelector('.color-block--avgtemp');
            x2 = (((avgtempicon.offsetLeft + avgtempitem.offsetLeft + bar.offsetLeft) * canvas.width) / canvas.clientWidth) - adjustedOffsetLeft;
            y2 = (bar.offsetTop + avgtempitem.offsetTop + avgtempicon.offsetTop) + 5;
            if (x1 && y1) {
              ctx.moveTo(x1, y1);
              ctx.lineTo(x2, y2);
              ctx.stroke();
            }
            x1 = x2;
            y1 = y2;
          }
        }, 300);
      });

      for (let i = 0; horizontalLines.length > i; i += 1) {
        horizontalLines[i].dataset.lineValue = lineValues[i];
      }
    });
  }

  const usagechartmobiletips = selectAll('[data-vue-app="usage-chart-mobile-tip"]');

  each(usagechartmobiletips, usagechartmobiletip => {
    const app = new Vue({ // eslint-disable-line no-unused-vars
      el: usagechartmobiletip,
      data: {
        showMobileTip: true,
      },
      /**
       * Methods
       */
      methods: {
        hideMobileTip() {
          this.showMobileTip = false;
        },
      },
    });
  });
}



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/portal/charts.js